module.exports = __webpack_public_path__ + "img/132.pleasant.79e86b21.svg";